import type { RouteObject } from 'react-router';

import { NotFoundChildRoute } from 'src/app/NotFoundChildRoute';

export const chatRoutes: RouteObject[] = [
  {
    index: true,
    lazy: () => import('./Chat').then((m) => ({ Component: m.Chat })),
  },
  {
    path: '*',
    element: (
      <NotFoundChildRoute routePath="/chat" linkText="Go back to chat" />
    ),
  },
];
